<script>
    import { createEventDispatcher, onMount } from 'svelte';    
    import { modesData, selectedMode, isModesToggleExpanded } from "../stores.js";


    let isExpanded = true;
    let selectedModeId = null;
    
    // Watch for changes in isExpanded and update the store accordingly
    /*
    $: if (isExpanded !== $isModesToggleExpanded) {
        isModesToggleExpanded.set(isExpanded);
    }*/

    function extendPopup() {
        if ($isModesToggleExpanded) {
            isExpanded = true;
        }
    }

    function retractPopup() {
        isExpanded = false;
    }
    
    // Toggling isModesToggleExpanded based on the checkbox state
    function handleToggleChange(event) {
        isModesToggleExpanded.set(event.target.checked);
    }

    function selectMode(modeId) {
        if (selectedModeId === modeId) {
            selectedModeId = null;
            selectedMode.set(null);
        } else {
            selectedModeId = modeId;
            selectedMode.set($modesData.get(modeId));
        }
    }

    /*// Set up an event listener for the custom event
    onMount(() => {
        document.addEventListener('togglePopup', togglePopupVisibility);
    });

    function handleKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            togglePopupVisibility();
        }
    }*/


    
</script>

<label class="toggle-switch">
    <input type="checkbox" on:change={handleToggleChange} checked={$isModesToggleExpanded} />
    <span class="slider round"></span>
</label>

{#if $isModesToggleExpanded}
{#if isExpanded}
    <div class="modes-container">
        {#each Array.from($modesData.values()) as mode}
            <div class="mode-item">
                {#if mode.assistantIconUrl}
                    <img src={mode.assistantIconUrl} alt="--" class="mode-icon" />
                {:else}
                    <svg width="32" height="32" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="mode-icon">
                        <path d="M9 1.23749V10M9 10L16.65 5.64431M9 10L1.35 5.64431M9 10V18.7625M16.65 14.3557L9.6993 10.3982C9.44406 10.2528 9.31644 10.1802 9.18136 10.1517C9.06165 10.1265 8.93835 10.1265 8.81864 10.1517C8.68356 10.1802 8.55594 10.2528 8.3007 10.3982L1.35 14.3557M17.1 13.7433V6.25669C17.1 5.94007 17.1 5.78176 17.0545 5.64114C17.0144 5.51673 16.9486 5.40236 16.8619 5.30582C16.7636 5.1969 16.6289 5.12074 16.3593 4.96843L9.6993 1.17736C9.44406 1.03197 9.31644 0.959271 9.18136 0.93072C9.06165 0.905525 8.93835 0.905525 8.81864 0.93072C8.68356 0.959271 8.55594 1.03197 8.3007 1.17736L1.6407 4.96843C1.37109 5.12074 1.23628 5.1969 1.13805 5.30582C1.05139 5.40236 0.985595 5.51673 0.94546 5.64114C0.9 5.78176 0.9 5.94007 0.9 6.25669V13.7433C0.9 14.0599 0.9 14.2182 0.94546 14.3589C0.985595 14.4833 1.05139 14.5976 1.13805 14.6942C1.23628 14.8031 1.37109 14.8793 1.6407 15.0316L8.3007 18.8226C8.55594 18.968 8.68356 19.0407 8.81864 19.0693C8.93835 19.0945 9.06165 19.0945 9.18136 19.0693C9.31644 19.0407 9.44406 18.968 9.6993 18.8226L16.3593 15.0316C16.6289 14.8793 16.7636 14.8031 16.8619 14.6942C16.9486 14.5976 17.0144 14.4833 17.0545 14.3589C17.1 14.2182 17.1 14.0599 17.1 13.7433Z" stroke="#72CDB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                {/if}
                <span class="mode-name">{mode.modeName}</span>
                <label class="mode-toggle">
                    <input type="checkbox" checked={selectedModeId === mode.id} on:change={() => selectMode(mode.id)} />
                    <span class="mode-slider round"></span>
                </label>
            </div>
        {/each}
        <svg on:click={retractPopup} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.64 122.88" class="retract-icon">
            <g transform="scale(-1, 1) translate(-120.64, 0)">
                <path d="M54.03,108.91c-1.55,1.63-2.31,3.74-2.28,5.85c0.03,2.11,0.84,4.2,2.44,5.79l0.12,0.12c1.58,1.5,3.6,2.23,5.61,2.2 c2.01-0.03,4.01-0.82,5.55-2.37c17.66-17.66,35.13-35.61,52.68-53.4c0.07-0.05,0.13-0.1,0.19-0.16c1.55-1.63,2.31-3.76,2.28-5.87 c-0.03-2.11-0.85-4.21-2.45-5.8l-0.27-0.26C100.43,37.47,82.98,19.87,65.46,2.36C63.93,0.82,61.93,0.03,59.92,0 c-2.01-0.03-4.03,0.7-5.61,2.21l-0.15,0.15c-1.57,1.58-2.38,3.66-2.41,5.76c-0.03,2.1,0.73,4.22,2.28,5.85l47.22,47.27 L54.03,108.91L54.03,108.91z M2.26,106.91c-1.54,1.62-2.29,3.73-2.26,5.83c0.03,2.11,0.84,4.2,2.44,5.79l0.12,0.12 c1.57,1.5,3.6,2.23,5.61,2.21c2.01-0.03,4.02-0.82,5.55-2.37C31.01,101.2,48.87,84.2,66.39,67.12c0.07-0.05,0.14-0.11,0.21-0.17 c1.55-1.63,2.31-3.76,2.28-5.87c-0.03-2.11-0.85-4.21-2.45-5.8C48.94,38.33,31.36,21.44,13.83,4.51l-0.12-0.13 c-1.53-1.54-3.53-2.32-5.54-2.35C6.16,2,4.14,2.73,2.56,4.23L2.41,4.38C0.84,5.96,0.03,8.05,0,10.14c-0.03,2.1,0.73,4.22,2.28,5.85 l47.18,45.24L2.26,106.91L2.26,106.91z"/>
            </g>
        </svg>
    </div>
    {/if}
    <svg on:click={extendPopup} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.64 122.88" class="extend-icon">
        <g>
            <path d="M54.03,108.91c-1.55,1.63-2.31,3.74-2.28,5.85c0.03,2.11,0.84,4.2,2.44,5.79l0.12,0.12c1.58,1.5,3.6,2.23,5.61,2.2 c2.01-0.03,4.01-0.82,5.55-2.37c17.66-17.66,35.13-35.61,52.68-53.4c0.07-0.05,0.13-0.1,0.19-0.16c1.55-1.63,2.31-3.76,2.28-5.87 c-0.03-2.11-0.85-4.21-2.45-5.8l-0.27-0.26C100.43,37.47,82.98,19.87,65.46,2.36C63.93,0.82,61.93,0.03,59.92,0 c-2.01-0.03-4.03,0.7-5.61,2.21l-0.15,0.15c-1.57,1.58-2.38,3.66-2.41,5.76c-0.03,2.1,0.73,4.22,2.28,5.85l47.22,47.27 L54.03,108.91L54.03,108.91z M2.26,106.91c-1.54,1.62-2.29,3.73-2.26,5.83c0.03,2.11,0.84,4.2,2.44,5.79l0.12,0.12 c1.57,1.5,3.6,2.23,5.61,2.21c2.01-0.03,4.02-0.82,5.55-2.37C31.01,101.2,48.87,84.2,66.39,67.12c0.07-0.05,0.14-0.11,0.21-0.17 c1.55-1.63,2.31-3.76,2.28-5.87c-0.03-2.11-0.85-4.21-2.45-5.8C48.94,38.33,31.36,21.44,13.83,4.51l-0.12-0.13 c-1.53-1.54-3.53-2.32-5.54-2.35C6.16,2,4.14,2.73,2.56,4.23L2.41,4.38C0.84,5.96,0.03,8.05,0,10.14c-0.03,2.1,0.73,4.22,2.28,5.85 l47.18,45.24L2.26,106.91L2.26,106.91z"/>
        </g>
    </svg>
{/if}

<style>
.retract-icon, .extend-icon {
    width: 40px; /* Adjust the size as needed */
    height: 40px; /* Adjust the size as needed */
}

.extend-icon path {
    stroke: white; /* Set the stroke color to white */
    stroke-width: 2px; /* Set the stroke width to 1px */
    fill: none; /* Ensure that the path is not filled */
}




.modes-container {
        position: absolute;
        left: 100%; 
/*        right: 0%; */
        width: 300px; 
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
        padding: 10px;
        z-index: 10;
        bottom: 12vh;
    }

.toggle-switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .toggle-switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .modes-list {
        background-color: white;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 10px;
        margin-top: 10px;
    }
    .mode-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .mode-icon {
        height: 30px;
        width: 30px;
        margin-right: 10px;
        border-radius: 15px;
        object-fit: cover;
    }

    .mode-name {
        flex-grow: 1;
    }

    .mode-toggle {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .mode-toggle input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .mode-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .mode-slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .mode-toggle input:checked + .mode-slider {
        background-color: #2196F3;
    }

    .mode-toggle input:checked + .mode-slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    .mode-slider.round {
        border-radius: 34px;
    }

    .mode-slider.round:before {
        border-radius: 50%;
    }


/* Media query for portrait mode */
@media (orientation: portrait) {
    .modes-container {
        left: auto;  /* Reset left to auto so it doesn't affect the right positioning */
        right: 0%;   /* Position to the right */
    }

    /* Additional transformations for the SVG icons inside the retract and extend divs */
    .retract-icon {
/*        transform: rotate(-90deg);  */
    }
    .extend-icon {
/*        transform: rotate(-90deg);  */
    }

    /* Hide the icons in portrait mode */
    .retract-icon, .extend-icon {
        display: none;
    }

}


</style>
